import React from "react";
import SelectCustom from "./SelectCustom";
import BusinessSearch from "../business/BusinessSearch";
import JobSearch from "../job/JobSearch";
import PropertySearch from "../property/PropertySearch";
import EventFilters from "../events/EventFilters";
import Filter from "../../gallery/icons/filter.png";

function SearchFilters({ dataPage, search, categorySelectedOption, locationSelectedOption, breadcrumbLocation, queryCategory, queryLocation, handleRedirect, handlePropSearch, queryTitle, queryJob, queryLevel, queryDisclosed, querySort, queryType, queryCTax, querySharing, queryDeposit, queryGender, queryBills, querySafe, queryFree, paginationData }) {
  return (
    <div className="row">
      <div className="showing-result">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            {paginationData && paginationData.total > 0 && (
              <>
                Showing&nbsp;
                {paginationData ? paginationData.current_page * paginationData.per_page + 1 - paginationData.per_page : ""}-{paginationData ? (paginationData.total < paginationData.per_page ? paginationData.total : paginationData.current_page * paginationData.per_page) : ""}
                &nbsp;of&nbsp;
                {paginationData ? paginationData.total : ""} results
              </>
            )}
          </div>
          <div className="hidden-sm hidden-md">
            <a className="refine-xxs refine-text" href="/" data-bs-toggle="modal" data-bs-target="#exampleModal">
              <img src={Filter} alt="Filter" />
            </a>
          </div>
        </div>
      </div>
      <div className="toggle-search hidden-xs hidden-sm">
        {categorySelectedOption && queryCategory && dataPage === "business" && (
          <div className="col-lg-12 col-md-12 mb-3">
            <SelectCustom id={"category_select"} options={search ? search.categories : false} handle={handleRedirect} type="category" selectedOption={categorySelectedOption} />
          </div>
        )}
        {locationSelectedOption && breadcrumbLocation && queryLocation && (
          <div className="col-lg-12 col-md-12 mb-3">
            <SelectCustom id={"location_select"} options={search ? search.locations : false} type="location" handle={handleRedirect} selectedOption={locationSelectedOption} />
          </div>
        )}
      </div>

      {/* Page-specific filter components */}
      {dataPage === "business" && <BusinessSearch pageTitle={`Nepalese ${categorySelectedOption.label} in ${breadcrumbLocation}`} searchCategories={search.categories ? search.categories : ""} queryCategory={queryCategory ? queryCategory : ""} />}
      {dataPage === "job" && <JobSearch pageTitle={`Nepalese ${categorySelectedOption.label} in ${breadcrumbLocation}`} title={queryTitle ? queryTitle : ""} job={queryJob ? queryJob : "all"} level={queryLevel ? queryLevel : "all"} disclosed={queryDisclosed ? queryDisclosed : 0} sort={querySort ? querySort : null} handle={handlePropSearch} />}
      {dataPage === "property" && <PropertySearch pageTitle={`Nepalese ${categorySelectedOption.label} in ${breadcrumbLocation}`} type={queryType ? queryType : 0} ctax={queryCTax ? queryCTax : 0} sharing={querySharing ? querySharing : 0} deposit={queryDeposit ? queryDeposit : 0} gender={queryGender ? queryGender : 3} bills={queryBills ? queryBills : 0} handle={handlePropSearch} />}
      {dataPage === "event" && <EventFilters pageTitle={`Nepalese ${categorySelectedOption.label} in ${breadcrumbLocation}`} safe={querySafe ? querySafe : 0} category={queryCategory ? queryCategory : 4} time={0} free={queryFree ? queryFree : 0} handle={handlePropSearch} />}
    </div>
  );
}

export default SearchFilters;
